import { useCurrentUser } from 'new/hooks/adapters/useCurrentUser';

export function useDataProductsDrawer(datasetId: number, domainId?: number) {
  const user = useCurrentUser();

  const isCustodian = user?.custodian_for_domains.includes(domainId) || user.isOrgCustodian;

  return { isCustodian, user };
}
